define('viewmodels/pages/cash/CannotWithdrawViewModel',['knockout'], function (ko) {

    return function (withdrawModel, getField, player) {
        var self = this;

        self.minAmount = withdrawModel.playerPaymentMethod.property('minToWithdraw');

        self.balance = player.wallet.balance.property('amount');
        self.bonusBalance = player.bonus.balance.property('amount');
        self.realBalance = player.realMoney.property('amount');
        self.wagerAmount = player.bonus.wageringRequirement.property('amount');

        self.summary = getField('amount_summary');
        self.wagerLabel = getField('remaining_wager');
        self.message = getField('not_enough_money_to_withdraw_warning');
    };
});

